import MoneyFormat from './MoneyFormat';

export default function Prices({ originalPrice, currency }) {
  return originalPrice ? (
    <div className="GiftBox-Offer-Card-Line-Prices">
      <span className="GiftBox-Offer-Card-OriginalPrice line-through text-gray-600">
        {MoneyFormat({ amount: originalPrice, currency })}
      </span>
      &nbsp;
      <span className="GiftBox-Offer-Card-DiscountedPrice text-primary-600 font-semibold">
        {MoneyFormat({ amount: 0, currency })}
      </span>
    </div>
  ) : null;
}
